import { render, staticRenderFns } from "./feishu.vue?vue&type=template&id=72bd4daa&scoped=true"
import script from "./feishu.vue?vue&type=script&lang=js"
export * from "./feishu.vue?vue&type=script&lang=js"
import style0 from "./feishu.vue?vue&type=style&index=0&id=72bd4daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd4daa",
  null
  
)

export default component.exports